export default __webpack_public_path__ + "static/media/downarrow.387aa4d8.svg";